import React from 'react'
import Highcharts from 'highcharts'


const defaultOptions = {
	chart: {
		backgroundColor: null,
		borderWidth: 0,
		type: 'line', // 'area'
		margin: [2, 0, 2, 0],
		// width: 120,
		// height: 24,
		style: {
			overflow: 'visible'
		},

		// small optimalization, saves 1-2 ms each sparkline
		skipClone: true
	},
	exporting: {
		buttons: {
		  contextButton: {
			enabled: false
		  }
		}
	  },
	title: {
		text: ''
	},
	credits: {
		enabled: false
	},
	xAxis: {
		labels: {
			enabled: false
		},
		title: {
			text: null
		},
		startOnTick: false,
		endOnTick: false,
		tickPositions: []
	},
	yAxis: {
		endOnTick: false,
		startOnTick: false,
		labels: {
			enabled: false
		},
		title: {
			text: null
		},
		tickPositions: [0]
	},
	legend: {
		enabled: false
	},
	tooltip: {
		backgroundColor: 'white',
		borderWidth: 1,
		hideDelay: 0,
		shared: true,
		padding: 8,
		borderColor: 'silver',
		borderRadius: 3,
		positioner: function (w, h, point) {
			return { x: point.plotX - w / 2, y: point.plotY - h };
		}
	},
	plotOptions: {
		series: {
			animation: false,
			lineWidth: 2,
			shadow: false,
			states: {
				hover: {
					lineWidth: 2
				}
			},
			marker: {
				radius: 1,
				states: {
					hover: {
						radius: 2
					}
				}
			},
			fillOpacity: 0.25
		},
		column: {
			negativeColor: '#910000',
			borderColor: 'silver'
		}
	},

	series: [{
		data: [1, 2, 3]
	}]
};


class SparkLineChart extends React.Component {
	// useless constructor
	// constructor(props) {
	// 	super(props)
	// }

	componentDidMount() {
		const options = Highcharts.merge(defaultOptions, this.props.options)
		this.chart = Highcharts.chart(this.container, options)
	}

	componentWillUnmount() {
		this.chart.destroy()
	}

	render() {
		return (
			<div className='col-lg-12 sparkline'
				ref={container => this.container = container}
			>
			</div>
		)
	}
}

export default SparkLineChart


// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowValues/SparkLineChart.jsx